module.exports = __webpack_public_path__ + "static/media/logobco_ESPIGA.1358979d.png";